import { useState, useEffect, useRef } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { useMediaQuery } from 'react-responsive';
import { ReactComponent as SearchIcon } from './assets/search.svg';
import { ReactComponent as CrossIcon } from './assets/cross.svg';
import Results from './resultPage';
import Loader from './loader';
import style from './style.module.scss';
import clsx from 'clsx';

function Search({ isHeader, isMenuOpen, isHome = false }) {
    const [typeSenseOptions, setTypeSenseOptions] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [results, setResults] = useState([]);
    const [noResults, setNoResults] = useState(false);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const isTablet = useMediaQuery({
        query: '(max-width: ' + style.tabletBreakpoint + ')',
    });
    const inputRef = useRef(null);

    useEffect(() => {
        apiFetch({
            path: 'smartfire/v1/getTypeSenseAdminSettings',
        }).then((data) => {
            setTypeSenseOptions(data);
        });
    }, []);

    useEffect(() => {
        if (!search) {
            setLoading(false);
            setNoResults(false);
            setResults([]);
            return;
        }

        const doSearchRequest = async (collection) => {
            const params = new URLSearchParams({
                q: search,
                query_by: 'post_title,post_content',
                filter_by: 'post_status:=`publish`',
                per_page: '100',
                'x-typesense-api-key': typeSenseOptions?.search_api_key,
            });

            return await fetch(
                typeSenseOptions?.protocol +
                    typeSenseOptions?.node +
                    (typeSenseOptions && typeSenseOptions.port ? ':' + typeSenseOptions.port : '') +
                    '/collections/' +
                    collection +
                    '/documents/search?' +
                    params.toString(),
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            ).then((response) => response.json());
        };

        const doSearch = () => {
            Promise.all([doSearchRequest('post'), doSearchRequest('page'), doSearchRequest('agenda')])
                .then((res) => {
                    const hits = [...res[0]?.hits, ...res[1]?.hits, ...res[2]?.hits];
                    setNoResults(!(res[0] && hits && hits.length > 0));
                    setResults(hits);
                })
                .finally(() => setLoading(false));
        };

        setLoading(true);

        let inputTimer = setTimeout(doSearch, 300);

        return () => clearTimeout(inputTimer);
    }, [
        search,
        typeSenseOptions,
        typeSenseOptions?.node,
        typeSenseOptions?.protocol,
        typeSenseOptions?.search_api_key,
    ]);

    return (
        <>
            {isHeader && isTablet && (
                <div className={clsx(style.mobileSearch, showSearch && style.showSearch, isMenuOpen && style.hide)}>
                    {isHome ? (
                        <div
                            className={clsx(style.searchInputButton, showSearch && style.searching)}
                            onClick={() => {
                                if (!showSearch) {
                                    setShowSearch(true);
                                    inputRef.current.focus();
                                }
                            }}
                        >
                            <span className={style.placeholder}>Rechercher...</span>
                            <div className={style.goldCircle}>
                                <SearchIcon className={style.searchIcon} />
                                <CrossIcon className={style.crossIcon} onClick={() => setShowSearch(false)} />
                            </div>
                        </div>
                    ) : (
                        <div className={style.searchButton}>
                            <SearchIcon className={style.searchIcon} onClick={() => setShowSearch(true)} />
                            <CrossIcon className={style.crossIcon} onClick={() => setShowSearch(false)} />
                        </div>
                    )}
                </div>
            )}

            <div className={clsx(style.searchContainer, !isMenuOpen && showSearch && style.show)}>
                <input
                    ref={inputRef}
                    className={style.input}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder={'Rechercher...'}
                />

                <div className={style.searchButton}>{loading ? <Loader /> : <SearchIcon />}</div>

                <ul className={clsx(style.results, (noResults || results?.length) && style.hasResults)}>
                    {noResults ? (
                        <p className={style.noResult}>Aucun résultat n'a été trouvé</p>
                    ) : (
                        <Results results={results} />
                    )}
                </ul>
            </div>
        </>
    );
}

export default Search;
